export default {
  data() {
    return {
      formRelationship: {
        id: "", // id of collction (leave blank if not required)
        idi: 0, // index againts other relationships
        limit: 0, // any limits on size
        path: "", // where is the collection, C or F or U etc
        rank: 0, // 1 is child and 2 is parent, 0 is not required
        sync: false, // sync requiremnt
        tag: "", // tag of document example D1, A2
        tagr: "", // tag of relatioship
        title: "", // title of relatioship
        type: "" // type of relationship A, B, C
      }, // yext
      formRelationshipLink: {
        id: "", // id of master / child (Invetsigation teport id)
        idi: 0, // index againts other link relationships
        idg: "", // generated id;
        dbs: "", // where is the collection, C or F or U etc
        did: "", // document of master
        sync: false,
        tag: "", // tag of relationsip (Invetsigation Report tag)
        title: "", // title of relatioship (Invetsigation teport titl)
        type: "C",
        rank: "S" // source document
      }, // short is for wh
      formRelationshipItem: {
        ctag: "", // company tag
        ctitle: "", // company title
        cdid: "", // company id
        cidg: "", // company generated igg
        did: "", // document did
        id: "", // doc id
        idi: "", // document idi
        idg: "", // document oducment idg
        title: "", // document name
        tag: "", // document document tag
        ftitle: "", // f1 titl
        ftag: "", // f1 tag
        fdid: "", // f1 id
        fidg: ""
      },
      formRelationshipAssetTree: {
        did: "", // document did
        id: "", // doc id
        idi: "", // document idi
        idg: "", // document oducment idg
        title: "", // document name
        tag: "" // document document tag
      },
      formSourceItem: {
        ddid: "", // document doc did
        dname: "", // document name / title
        dtag: "", // document tag / type of doc
        didg: "", // document id for doc
        did: "", // doc id
        cid: "", // company tag
        cdid: "",
        cname: "", // company legal name
        fname: "", // f1 name
        fid: "", // f1 tag
        fdid: "", // f1 id
        type: "S" // this is source doc
      },
      formRelpsUser: {
        d4: [], // attachments
        k4: [], // imports
        h1: [],
        h2: [],
        h3: [],
        h4: []
      },
      formRelpsCompany: {
        d4: [], // attachment
        g4: [], // roles
        k4: [] // imports
      },
      formRelpsFacility: {
        d4: [], // attachment
        g4: [], // roles
        k4: [], // imports
        s1: [], // hazards
        s2: [], // risk assessment
        s3: [], // barriers
        s4: [], // controls
        s5: [] // outcomes
      },
      formRelpsAsset: {
        a1: [], // assets tree
        d4: [], // attachment
        k4: [], // relationships
        l1: [] // bill of materials / parts list
      },
      formRelpsAccess: {
        link: [] // master object for access
      },
      formRelpsNotification: {
        d4: [], // attachment
        k4: [] // import relationships
      },
      formRelpsWorkRequest: {
        b3: [], // action register
        d4: [], // attachments
        e5: [], // technical results
        g4: [], // roles
        k4: [], // relationships
        l5: [], // order parts
        h5: [], // human resources
        o5: [], // permit request
        s1: [], // hazards
        s3: [], // barriers
        s4: [], // controls
        s5: [], // outcomes
        w5: [] // tasks list
      },
      formRelpsWorkCall: {
        b3: [], // action register
        d4: [], // attachments
        e5: [], // technical results
        g4: [], // roles
        k4: [], // relationships
        l5: [], // order parts
        h5: [], // human resources
        o5: [], // permit request
        s1: [], // hazards
        s3: [], // barriers
        s4: [], // controls
        s5: [], // outcomes
        w5: [] // tasks list
      },
      formRelpsProcedure: {
        d4: [], // attachments
        g4: [], // resposibilities
        k4: [], // documents
        w5: [] // tasks
      },
      formRelpsProgram: {
        d4: [], // attachments
        g4: [], // resposibilities
        k4: [], // documents
        e5: [] // results
      },
      formRelpsResult: {
        d4: [], // attachments
        g4: [], // resposibilities
        k4: [], // documents
        e5: [] // results
      },
      formRelpsOrder: {
        d4: [], // attachments
        k4: [], // relationships
        b3: [], // actions
        g4: [] // roles
      },
      formRelpsResource: {
        d4: [],
        asset: [],
        k4: []
      },
      formRelpsEngineering: {
        b3: [], // actions
        d4: [], // attachments
        k4: [], // imported documents
        g4: [], // roles and responsibilties
        s2: [] // risk assessment
      },
      formRelpsAction: {
        d4: [], // attachments
        k4: [], // relationships
        g4: [] // roles and resposibilities
      },
      formRelpsMaterial: {
        d4: [], // attachments
        k4: [], // relationships
        l7: [] // inventory
      },
      formRelpsMaterialList: {
        d4: [], // attachments
        k4: [],
        eng: [] // enineering disciplines
      },
      formRelpsIncidentRisk: {
        b3: [], // actions
        d4: [], // attachments
        k4: [], // imported documents
        g4: [], // roles and responsibilties
        s1: [], // hazards identified
        s2: [], // risk assessment
        s3: [], // barriers
        s4: [], // controls
        s5: [], // outcomes
        s7: [] // causes
      },
      formRelpsBudget: {
        d4: [], // attachments
        g4: [], // roles
        k4: [] // imported docuemnt
      },
      formRelpsHazard: {
        d4: [], // attachments
        g4: [], // g4 and resposibilities
        k4: [], // k4ed documents
        s3: [], // risk hazards to manage the hazard
        s4: [] // risk control to manage the hazard
      },
      formRelpsEquipment: {
        d4: [], // attachments
        e3: [], // technical analysis for equipment
        g4: [], // g4 and resposibilities
        k4: [] // k4 relationships documents
      },
      formRelpsPlan: {
        b7: [], // business limits
        d4: [], // attachments
        g4: [],
        k4: []
      },
      formRelpsMaintPlan: {
        a1: [], // asset register
        b3: [], // action register
        d4: [], // attachments
        e5: [], // technical results
        g4: [], // roles
        k4: [], // relationships
        l5: [], // parts list
        h5: [], // human resources
        o5: [], // permit request
        s1: [], // hazards register
        s3: [], // barriers
        s4: [], // controls
        s5: [], // outcomes
        w5: [] // tasks list
      },
      formRelpsMaintStrategy: {
        b3: [], // actions
        d4: [], // attachments
        k4: [], // relatiionships
        g4: [], // roles
        m1: [], // maint activity
        s3: [], // barriers
        s4: [] // controls
      },
      formRelpsMaintennaceAssurance: {
        d4: [], // attachments
        k4: [],
        eng: [] // enineering disciplines
      },
      formRelpsMaintennaceStrategy: {
        d4: [], // attachments
        k4: [],
        g4: [],
        eng: [] // enineering disciplines
      },
      formRelpsMaintenancePlan: {
        d4: [], // attachments
        k4: [],
        eng: [] // enineering disciplines
      },
      formRelpsMaintenanceCall: {
        d4: [], // attachments
        k4: [],
        eng: [] // enineering disciplines
      }
    };
  }
};
